<template>
  <div class="page">
    <div class="pageTitleBox">
      <div class="boxNameL">
        商品订单详情
        <!-- 3 支付成功 8：已完成 -->
        <!-- <el-button
          plain
          v-if="detail.state == 3 || detail.state == 8"
          size="mini"
          style="margin-left: 10px"
          type="warning"
          @click="
            $router.push({
              path: '/huifang/huifangList',
              query: { id: detail._id, from: 'order' },
            })
          "
          >回访</el-button
        > -->
        <el-button
          plain
          v-if="detail.isHaveInvoices == false && $buttonAuthority('dingdan-saleOrder-addedit')"
          size="mini"
          style="margin-left: 10px"
          type="warning"
          @click="addIsHaveInvoices"
          >添加发票</el-button
        >
        <el-button
          plain
          v-if="detail.isHaveInvoices == true && $buttonAuthority('dingdan-saleOrder-addedit')"
          size="mini"
          style="margin-left: 10px"
          type="warning"
          @click="delIsHaveInvoices"
          >删除发票</el-button
        >
      </div>
      <div class="boxNameR">
        <el-button
          v-if="
            !$public.isNull(detail.other_param) && detail.order_type_id == 8
          "
          type="warning"
          @click="
            $router.push({
              path: '/dingdan/dingjinOrderList',
              query: { str: detail.other_param },
            })
          "
          size="small"
          >关联订金订单</el-button
        >
        <el-button
          v-if="
            !$public.isNull(detail.other_param) && detail.order_type_id == 10
          "
          type="warning"
          @click="s
            $router.push({
              path: '/dingdan/huotiOrderList',
              query: { str: detail.other_param },
            })
          "
          size="small"
          >关联活体订单</el-button
        >
        <el-button type="warning" @click="$router.back()" size="small"
          >返回</el-button
        >
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">订单编号：</div>
        <div class="msgValue">{{ detail.no }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">顾客：</div>
        <div class="msgValue">{{ detail.user_info.nick_name }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">电话：</div>
        <div class="msgValue">{{ detail.user_info.user_mobile }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">宠物：</div>
        <div class="msgValue"></div>
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">订单类型：</div>
        <div class="msgValue">{{ detail.order_type }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">订单状态：</div>
        <div class="msgValue">{{ $public.formatOrderState(detail.state) }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">总计：</div>
        <div class="msgValue">￥{{ detail.total_price }}</div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">订单备注：</div>
        <div class="msgValue">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            :content="detail.remark"
          >
            <div
              slot="reference"
              style="
                display: inline-block;
                width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                vertical-align: middle;
                cursor: pointer;
              "
            >
              {{ detail.remark }}
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">优惠券：</div>
        <div class="msgValue">
          <span v-if="detail.coupon_list && detail.coupon_list.length > 0">
            <span
              style="padding-right: 30px"
              v-for="(item, index) in detail.coupon_list"
              :key="index"
              >{{ item.coupon_name }} ({{ item._no }})</span
            >
          </span>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">创建人：</div>
        <div class="msgValue">{{ detail.create_manager_name }}</div>
      </div>
      <div class="msgItem" style="width: 25%">
        <div class="msgLabel">操作时间：</div>
        <div class="msgValue">{{ $public.FTime(detail.create_time) }}</div>
      </div>
      <div class="msgItem" style="width: 25%">
        <div class="msgLabel">订金状态：</div>
        <div class="msgValue">
          {{ $public.isNull(detail.other_param) ? "未使用" : "已使用" }}
        </div>
      </div>
    </div>
    <div class="msg" style>
      <div class="msgItem">
        <div class="msgLabel">结算方式：</div>
        <div class="msgValue">
          <span v-if="detail.pay_info">
            <el-button
              v-if="$buttonAuthority('dingdan-saleOrder-changezhifu')&&
                new Date().getTime() < detail.create_time * 1000 + 604800000
              "
              type="text"
              @click="changePayInfo"
              >修改</el-button
            >
            <span
              style="padding-right: 30px"
              v-for="(item, index) in detail.pay_info.pay_list"
              :key="index"
            >
              <span style="padding-right: 2px">
                {{ $public.formatPayTypeState(item.pay_type) }}
                <el-tooltip
                  v-if="item.pay_type === 16"
                  effect="light"
                  placement="bottom-start"
                >
                  <div slot="content" class="tip">
                    <el-table :data="giftCardList">
                      <el-table-column
                        label="卡号"
                        prop="card_no"
                        width="150"
                      ></el-table-column>
                      <el-table-column
                        label="类型"
                        prop="denomination"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <span v-if="scope.row.card_type === '1'">现金卡</span>
                          <span v-if="scope.row.card_type === '2'">活体卡</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="消费金额"
                        prop="money"
                        width="150"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <img
                    style="width: 20px; vertical-align: middle"
                    src="../../../../assets/img/icon_eye.jpg"
                  />
                </el-tooltip>
              </span>
              {{ item.money }}
            </span>
          </span>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">结算备注：</div>
        <div class="msgValue">
          <span v-if="detail.pay_info">{{ detail.pay_info.pay_remark }}</span>
        </div>
      </div>
      <div class="msgItem" style="width: 50%">
        <div class="msgLabel">结算时间：</div>
        <div class="msgValue">
          <span v-if="detail.pay_info">{{
            $public.FTime(detail.pay_info.pay_time)
          }}</span>
        </div>
      </div>
      <div class="msgItem">
        <div class="msgLabel">发票状态：</div>
        <div class="msgValue">
          {{ detail.isHaveInvoices == true ? "已添加" : "未添加" }}
        </div>
      </div>
    </div>
    <div class="pageConBox" v-if="detail._id">
      <el-table
        :data="tableData"
        max-height="800"
        default-expand-all
        style="width: 100%; margin-bottom: 10px"
        :row-key="record=>record.tableKey"
      >
        <el-table-column label="商品名称" width="240">
          <template slot-scope="scope">
            {{
              scope.row.goodsList
                ? scope.row.gift == "gift"
                  ? "赠品"
                  : scope.row.goodsName
                : scope.row.goodsName
            }}<span v-for="(item,index) in scope.row.petTag" :key="index">({{ item }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="customCode" label="宠物" width="80">
          <template slot-scope="scope">
            <span v-if="!$public.isNull(scope.row.pets_info)">{{
              scope.row.pets_info.pets_name
            }}{{
              scope.row.petTag
            }}</span> 
          </template>
        </el-table-column>

        <el-table-column label="规格" width="140">
          <template slot-scope="scope">
            {{ scope.row.skuValue }}
          </template>
        </el-table-column>
        <el-table-column label="条码" width="140">
          <template slot-scope="scope">
            {{ scope.row.barCode }}
          </template>
        </el-table-column>
        <el-table-column label="单位" width="50">
          <template slot-scope="scope">
            {{
              scope.row.goodsList
                ? scope.row.gift == "gift"
                  ? ""
                  : scope.row.unit
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column  label="标准价" width="70">
          <template slot-scope="scope">
            {{
              scope.row.goodsList
                ? scope.row.gift == "gift"
                  ? ""
                  : scope.row.originalPrice
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="activityName"
          label="活动"
          width="120"
        ></el-table-column>
        <el-table-column prop="price" label="优惠价" width="70">
          <template slot-scope="scope">
            {{
              scope.row.goodsList
                ? scope.row.gift == "gift"
                  ? ""
                  : scope.row.price
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="num" label="数量" width="190">
          <template slot-scope="scope">
            <el-input-number  v-if="
              detail.order_type_id != 6 &&
              detail.order_type_id != 8 &&
              detail.order_type_id != 9 &&
              !(
                detail.order_type_id === 10 &&
                !$public.isNull(detail.other_param)
              )
            " v-model="scope.row.num" controls-position="right"
             :min="0"  size="small" @change="handleChange(scope)"></el-input-number>
           <div v-else>
            {{
              scope.row.goodsList
                ? scope.row.gift == "gift"
                  ? ""
                  : scope.row.num
                : ""
            }}
           </div>
          </template>
        </el-table-column>
        <el-table-column label="总金额">
          <template slot-scope="scope">
            {{
              scope.row.goodsList
                ? scope.row.gift == "gift"
                  ? ""
                  : scope.row.totalMoney
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="staff" label="销售人员" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.goodsList">
              {{ scope.row.staff }}
              <el-button
                v-if="
                  ($buttonAuthority('dingdan-saleOrder-changeStaff')&&
                    !$public.isNull(scope.row.staff))
                "
                type="text"
                @click="changeStaff(scope.row)"
                >修改</el-button
              >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="detail.state == 3 && $buttonAuthority('dingdan-saleOrder-tuihuo')"
          label="退换货"
        >
          <template slot-scope="scope">
            <!-- 判断父级 -->
            <el-checkbox
              v-if="
                scope.row.goodsList &&
                scope.row.goodsList.length == 0 &&
                detail.order_type_id != 6 &&
                detail.order_type_id != 8 &&
                detail.order_type_id != 9
              "
              v-model="scope.row.returnState"
            ></el-checkbox>
            <!-- 判断子级 -->
            <el-checkbox
              v-if="
                !scope.row.goodsList &&
                detail.order_type_id != 6 &&
                detail.order_type_id != 8 &&
                detail.order_type_id != 9
              "
              v-model="scope.row.returnState"
            ></el-checkbox>
          </template>
        </el-table-column>
        <template slot="empty">
          <img
            src="../../../../assets/img/kong.png"
            style="width: 335px; padding-top: 50px"
          />
        </template>
      </el-table>
      <!-- 只有活体订单显示退宠/换宠 -->
      <div
        style="text-align: right; margin-right: 10px"
        v-show="
          detail.order_type_id == '8' &&
          detail.state >= '3'
        "
      >
        <el-button v-if="$buttonAuthority('dingdan-arrearsOrder-sendback')" plain @click="refundPet">退宠</el-button>
        <el-button v-if="$buttonAuthority('dingdan-arrearsOrder-exchange')" plain @click="replacePet">换宠</el-button>
      </div>
      <!-- 只有寄养订单显示 -->
      <div
        style="text-align: right; margin-right: 10px"
        v-show="
          detail.order_type_id == '6' &&
          detail.state == '3'
        ">
        <el-button v-if="$buttonAuthority('dingdan-saleOrder-jiyangTuikuan')" plain @click="sendPet">寄养退款</el-button>
      </div>
      <!-- 寄养退款弹框 -->
      <div v-if="drawerCareProduct_state">
        <drawerCareProduct
          @submit="drawerCareProduct_state = false"
          :tabInfo="detail"
        ></drawerCareProduct>
      </div>
      <!-- 退宠弹框 -->
      <div v-if="drawerSeeProduct_state">
        <drawerSeeProduct
          @submit="drawerSeeProduct"
          :tabInfo="tableData"
          :orderNo="detail.no"
          :row="detail"
        ></drawerSeeProduct>
      </div>
      <!-- 换宠弹框 -->
      <div v-if="drawerChange_state">
        <drawerChange
          @submit="drawerChange_state = false"
          :row="detail"
          :orderNo="detail.no"
          :tabInfo="tableData"
        ></drawerChange>
      </div>
    
      <el-row style="padding: 10px 0">
        <el-col
          v-if="detail.state == 3 && $buttonAuthority('dingdan-saleOrder-tuihuo')"
          :span="3"
          :offset="21"
        >
          <!-- <el-button v-if="detail.order_type_id == 1" type="warning" @click="openOrderReturnGoods('exchange')">换货</el-button> -->
          <el-button
            type="warning"
            v-if="
              detail.order_type_id != 6 &&
              detail.order_type_id != 8 &&
              detail.order_type_id != 9 &&
              !(
                detail.order_type_id === 10 &&
                !$public.isNull(detail.other_param)
              )
            "
            @click="openOrderReturnGoods('return')"
            size="small"
            >退货</el-button
          >
        </el-col>
      </el-row>
    </div>
    <!-- 换货 换货 换货 换货 换货 换货 -->
    <div v-if="dialogReturnGoodsState">
      <dialogExchangeGoods
        :orderDetail="detail"
        :returnTotalMoney="return_totalMoney"
        @submit="submit_dialogReturnGoods"
      ></dialogExchangeGoods>
    </div>
    <!-- 退货 退货 退货 退货 -->
    <el-dialog
      title="退货"
      :visible.sync="dialogReturnGoodsState1"
      width="850px"
    >
      <el-form>
        <div class="msgBox">
          <span>结算方式:</span>
          <div class="msgV">
            <span v-if="detail.pay_info">
              <el-button
                v-if="
                  $buttonAuthority('dingdan-saleOrder-changezhifu')&&
                  new Date().getTime() < detail.create_time * 1000 + 604800000
                "
                type="text"
                @click="changePayInfo"
                >修改</el-button
              >
              <span
                style="padding-right: 30px"
                v-for="(item, index) in detail.pay_info.pay_list"
                :key="index"
              >
                <span style="padding-right: 2px">
                  {{ $public.formatPayTypeState(item.pay_type) }}
                  <el-tooltip
                    v-if="item.pay_type === 16"
                    effect="light"
                    placement="bottom-start"
                  >
                    <div slot="content" class="tip">
                      <el-table :data="giftCardList">
                        <el-table-column
                          label="卡号"
                          prop="card_no"
                          width="150"
                        ></el-table-column>
                        <el-table-column
                          label="类型"
                          prop="denomination"
                          width="150"
                        >
                          <template slot-scope="scope">
                            <span v-if="scope.row.card_type === '1'"
                              >现金卡</span
                            >
                            <span v-if="scope.row.card_type === '2'"
                              >活体卡</span
                            >
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="消费金额"
                          prop="money"
                          width="150"
                        ></el-table-column>
                      </el-table>
                    </div>
                    <img
                      style="width: 20px; vertical-align: middle"
                      src="../../../../assets/img/icon_eye.jpg"
                    />
                  </el-tooltip>
                </span>
                {{ item.money }}
              </span>
            </span>
          </div>
        </div>
        <div class="msgBox">
          <span>退款金额:</span>
          <span>
            {{ returnMoney1 }}
          </span>
        </div>
        <div class="msgBox">
          <span>结算方式:</span>
          <span v-for="item in payList" :key="item.id">
            {{ $public.formatPayTypeState(item.pay_type) }} {{ item.money }}
          </span>
        </div>
        <div class="msgBox">
          <span>退换备注:</span>
          <div>
            <el-input
              type="textarea"
              v-model="remark"
              aria-placeholder="不能少于15字"
            ></el-input>
          </div>
        </div>
        <div class="msgBox" v-if="isReturnYuE">
          <div style="margin-left: 50px; vertical-align: middle">
            <div class="msgBoxL">收款人姓名:</div>
            <el-input
              v-model="returnAccountParam.name"
              placeholder="请输入收款人姓名"
            ></el-input>

            <div class="msgBoxL">开户行:</div>
            <el-input
              v-model="returnAccountParam.bank_name"
              placeholder="请输入开户行信息"
            ></el-input>

            <div class="msgBoxL">银行卡号:</div>
            <el-input
              v-model="returnAccountParam.card_no"
              placeholder="请输入卡号"
            ></el-input>
          </div>
        </div>
        <!-- <el-row v-if="detail.order_type==='活体'">
					<el-col :span="10" :offset="1">
						<el-form-item label="退款金额：" :label-width="formLabelWidth">
							{{returnMoney}}
						</el-form-item>
					</el-col>
        </el-row>-->
        <!-- <el-row>
          <el-col :span="24" :offset="1">
            <el-form-item label="退货备注：" :label-width="formLabelWidth">
              <div style="color: red">
                如需转账，备注中请务必输入：1.客户姓名，2.身份证号，3.手机号，4.银行名称，5.开户行名称，6.银行卡号
              </div>
              <el-input
                style="width: 600px"
                type="textarea"
                rows="7"
                v-model="form1.backRemark"
                autocomplete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogReturnGoodsState1 = false">取 消</el-button>
        <el-button type="warning" @click="addOrderReturnGoods">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 结算弹窗 -->
    <div>
      <dialogSettlement
        v-if="dialogSettlementState"
        :type="form.table.length == 0 ? 'returnGoods' : 'exchangeGoods'"
        :orderId="returnOrderId"
        @submit="dialogSettlementSubmit"
      ></dialogSettlement>
    </div>
    <!-- 结算弹窗 -->
    <div>
      <dialogSettlement
        v-if="dialogSettlementState_payInfo"
        :type="'changePayInfo'"
        :orderId="detail._id"
        @submit="dialogSettlementSubmit_payInfo"
      ></dialogSettlement>
    </div>
    <!-- 修改销售人员 -->
    <div v-if="curStaffId_state">
      <el-dialog
        title="修改销售人员"
        :visible="true"
        width="300px"
        @close="curStaffId_state = false"
        :close-on-click-modal="false"
      >
        <div>
          <el-select
            v-model="curStaffId"
            multiple
            filterable
            placeholder="请选择"
            size="mini"
          >
            <el-option
              popper-class="select"
              v-for="item in staffList"
              :key="item._id"
              :label="item.basic_info.nick_name"
              :value="item._id"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="curStaffId_state = false"
            >取 消</el-button
          >
          <el-button size="mini" type="warning" @click="submit_curStaffId"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import dialogExchangeGoods from "./dialogExchangeGoods.vue";
import dialogSettlement from "../../../../components/dialog_settlement.vue";
import del from "../../../../util/del.js";
import drawerSeeProduct from "./drawer_seeProduct.vue";
import drawerChange from "./drawer_Change.vue";
import drawerCareProduct from "./drawer_care.vue";

export default {
  components: {
    drawerCareProduct,
    dialogSettlement,
    dialogExchangeGoods,
    drawerSeeProduct,
    drawerChange,
  },
  data() {
    return {
      returnMoney1: "",
      payList: [],
      isReturnYuE: true,
      formLabelWidth: "100px",
      detail: {
        user_info: {},
      },
      tableData: [],
      // 礼品卡
      giftCardList: [],

      curIndex: "",
      // 支付弹窗
      dialogSettlementState: false,
      // 退换货
      o: null,
      returnOrderId: "", // 退换货订单ID
      returnGoods: [],
      scanningCode: "",
      scanningCodeInput: "",
      scanningCodeInput_return: "",
      return_totalMoney: 0, // 退货商品总价
      form_table_totalMoney: 0, // 录入商品总价
      dialogReturnGoodsState: false, // 换
      form: {
        backState: 1,
        backRemark: "",
        table: [],
      },
      dialogReturnGoodsState1: false, // 退
      form1: {
        backState: 1,
        backRemark: "",
      },
      returnMoney: 0,

      // 修改销售人员
      curRow: {},
      curStaffId_state: false,
      curStaffId: [],
      // 修改结算方式
      dialogSettlementState_payInfo: false,
      //退宠弹窗
      drawerSeeProduct_state: false,
      // 换宠
      drawerChange_state: false,
      //寄养
      drawerCareProduct_state: false,
      // 收款
      returnAccountParam: {
        name: "", //姓名
        bank_name: "", //开户行
        card_no: "",
      },
      remark: "", //退货备注
      curStaff: [], // 销售人员
      staffList: [], //销售人员列表
      staffList1: [], //销售人员列表
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  mounted() {
    console.log("详情", this.$route.query);
    this.getDetail();
    this.getStaffList();
    this.o = new del();
  },
  methods: {
    handleChange(scope){
      console.log(scope,'min');
      let num = 0;
					num += scope.row.num;
				this.$set(this.tableData[scope.$index],['num'],num);
    },
    drawerSeeProduct() {
      this.drawerSeeProduct_state = false;
      this.getDetail();
    },
    // 寄养退款
    sendPet() {
      this.drawerCareProduct_state = true;
    },
    // 打开退宠
    refundPet() {
      this.drawerSeeProduct_state = true;
    },
    // 打开换宠
    replacePet() {
      this.drawerChange_state = true;
    },
    // 打开退换货弹窗
    openOrderReturnGoods(state) {
      if (
        this.detail.pay_info &&
        this.detail.pay_info.gift_card_list &&
        this.detail.pay_info.gift_card_list.length > 0
      ) {
        this.$message({
          message: "该订单使用了礼品卡，不支持退换货",
          type: "error",
        });
        return;
      }
      if (state == "exchange") {
        // 换货
        // if(this.detail.order_type==='活体'){
        // 	let params = {
        // 		"orderNumber": this.detail.no,
        // 	}
        // 	let loading = this.$loading();
        // 	this.$http.get('/api/Order/Return/LivingQuery', params).then(res => {
        // 		loading.close();
        // 		if (res.code == 0) {
        // 			this.returnMoney = res.data.returnMoney;
        // 			this.dialogReturnGoodsState1 = true;
        // 			this.form1={
        // 				backState:1,
        // 				backRemark:'',
        // 			}
        // 		}
        // 	})
        // 	return ;
        // }
        this.returnGoods = [];
        this.return_totalMoney = 0;
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodsList.length > 0) {
            // 判断有码
            for (let a = 0; a < this.tableData[i].goodsList.length; a++) {
              if (this.tableData[i].goodsList[a].returnState) {
                // 选中
                let one = {
                  goodsId: this.tableData[i].goodsId,
                  goodsName: this.tableData[i].goodsName,
                  goodsType: 1,
                  skus: this.tableData[i].skus,
                  skuValue: this.tableData[i].skuValue,
                  model: this.tableData[i].model,
                  unit: this.tableData[i].unit,
                  originalPrice: this.tableData[i].originalPrice,
                  price: this.tableData[i].price,
                  num: 1,
                  remark: this.tableData[i].remark,
                  activityId: this.tableData[i].activityId,
                  activityName: this.tableData[i].activityName,
                  activityType:
                    this.tableData[i].activityType == null
                      ? 1
                      : this.tableData[i].activityType,
                  goodsList: [],
                };
                this.return_totalMoney = this.$public.jia(
                  this.return_totalMoney,
                  one.price
                );
                let two = {
                  goodsId: this.tableData[i].goodsList[a].goodsId,
                  goodsName: this.tableData[i].goodsList[a].goodsName,
                  customBarCode: this.tableData[i].goodsList[a].customCode,
                  specificationPrice: 0, // 商品规格单价
                  price: this.tableData[i].goodsList[a].price,
                  skus: this.tableData[i].goodsList[a].skus,
                  skuValue: this.tableData[i].goodsList[a].skuValue,
                  model: this.tableData[i].goodsList[a].model,
                  unit: this.tableData[i].goodsList[a].unit,
                  unitId: this.tableData[i].goodsList[a].unitId,
                  expiryDate: this.tableData[i].goodsList[a].validityStopDate,
                  isOut: true,
                };
                one.goodsList.push(two);
                this.returnGoods.push(one);
              }
            }
            console.log("有码退货", this.returnGoods);
          } else {
            //判断无码
            if (this.tableData[i].returnState) {
              // 选中
              let one = {
                goodsId: this.tableData[i].goodsId,
                goodsName: this.tableData[i].goodsName,
                goodsType: 1,
                skus: this.tableData[i].skus,
                skuValue: this.tableData[i].skuValue,
                model: this.tableData[i].model,
                unit: this.tableData[i].unit,
                originalPrice: this.tableData[i].originalPrice,
                price: this.tableData[i].price,
                num: 1,
                remark: this.tableData[i].remark,
                activityId: this.tableData[i].activityId,
                activityName: this.tableData[i].activityName,
                activityType:
                  this.tableData[i].activityType == null
                    ? 1
                    : this.tableData[i].activityType,
                goodsList: [],
              };
              this.return_totalMoney = this.$public.jia(
                this.return_totalMoney,
                one.price
              );
              this.returnGoods.push(one);
            }
            console.log("无码退货", this.returnGoods);
          }
        }
        if (this.returnGoods.length == 0) {
          this.$message({
            message: "请选择要换货的商品",
            type: "error",
          });
          return;
        }
        this.dialogReturnGoodsState = true;
      } else {
        // 退货
        console.log("退货", this.tableData);
        this.returnGoods = [];
        this.return_totalMoney = 0;
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].goodsList.length > 0) {
            console.log(this.tableData[i],'this.tableData[i]1111');
            // 判断有码
            let two = [];
            for (let a = 0; a < this.tableData[i].goodsList.length; a++) {
              if (this.tableData[i].goodsList[a].returnState) {
                // 选中
                this.return_totalMoney = this.$public.jia(
                  this.return_totalMoney,
                  this.tableData[i].price
                );
                two.push({
                  goodsId: this.tableData[i].goodsList[a].goodsId,
                  goodsName: this.tableData[i].goodsList[a].goodsName,
                  customBarCode: this.tableData[i].goodsList[a].customCode,
                  specificationPrice: 0, // 商品规格单价
                  goodsType: this.tableData[i].goodsList[a].goodsType,
                  price: this.tableData[i].goodsList[a].price,
                  skus: this.tableData[i].goodsList[a].skus,
                  skuValue: this.tableData[i].goodsList[a].skuValue,
                  model: this.tableData[i].goodsList[a].model,
                  unit: this.tableData[i].goodsList[a].unit,
                  unitId: this.tableData[i].goodsList[a].unitId,
                  expiryDate: this.tableData[i].goodsList[a].validityStopDate,
                  isOut: true,
                  recordId: this.tableData[i].goodsList[a]._id,
                });
              }
            }
            if (two.length > 0) {
              let one = {
                goodsId: this.tableData[i].goodsId,
                goodsName: this.tableData[i].goodsName,
                goodsType: this.tableData[i].goodsType,
                goodsItemsId: this.tableData[i].goodsItemsId,
                skus: this.tableData[i].skus,
                skuValue: this.tableData[i].skuValue,
                model: this.tableData[i].model,
                unit: this.tableData[i].unit,
                originalPrice: this.tableData[i].originalPrice,
                price: this.tableData[i].price,
                num: this.tableData[i].num,
                remark: this.tableData[i].remark,
                activityId: this.tableData[i].activityId,
                activityName: this.tableData[i].activityName,
                activityType:
                  this.tableData[i].activityType == null
                    ? 1
                    : this.tableData[i].activityType,
                goodsList: two,
                _id: this.tableData[i]._id,
              };
              this.returnGoods.push(one);
            }
            console.log("有码退货", this.returnGoods);
          } else {
            //判断无码
            if (this.tableData[i].returnState) {
              // 选中
              console.log(this.tableData[i],'this.tableData[i]???????');
              let one = {
                goodsId: this.tableData[i].goodsId,
                goodsName: this.tableData[i].goodsName,
                goodsType: this.tableData[i].goodsType,
                goodsItemsId: this.tableData[i].goodsItemsId,
                skus: this.tableData[i].skus,
                skuValue: this.tableData[i].skuValue,
                packingWayId:this.tableData[i].packingWayId,
                model: this.tableData[i].model,
                unit: this.tableData[i].unit,
                originalPrice: this.tableData[i].originalPrice,
                price: this.tableData[i].price,
                num: this.tableData[i].num,
                remark: this.tableData[i].remark,
                activityId: this.tableData[i].activityId,
                activityName: this.tableData[i].activityName,
                activityType:
                  this.tableData[i].activityType == null
                    ? 1
                    : this.tableData[i].activityType,
                _id: this.tableData[i]._id,
              };
              this.return_totalMoney = this.$public.jia(
                this.return_totalMoney,
                one.price
              );
              this.returnGoods.push(one);
            }
            console.log("无码退货", this.returnGoods);
          }
        }

        if (this.returnGoods.length == 0) {
          this.$message({
            message: "请选择要退货的商品",
            type: "error",
          });
          return;
        }
        let params = {
          orderNumber: this.detail.no,
          returnGoods: this.returnGoods,
        };
        this.$http
          .post("/api/ReturnOrder/CalculateReturnMoney", params)
          .then((res) => {
            // console.log(res);
            if (res.code == 0) {
              this.payList = res.data.payList;
              this.returnMoney1 = res.data.returnMoney;
              res.data.payList.forEach((item) => {
                if (item.pay_type == 6 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 7 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 8 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 9 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 10 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 12 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 14 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
                if (item.pay_type == 16 && item.money !== 0) {
                  this.isReturnYuE = false;
                }
              });
            }
          });
        this.dialogReturnGoodsState1 = true;
        this.form1 = {
          backState: 1,
          backRemark: "",
        };
      }
    },
    // submit_换货
    submit_dialogReturnGoods(obj) {
      this.form.backState = obj.data.form.backState;
      this.form.backRemark = obj.data.form.backRemark;
      this.form.table = obj.data.table;
      if (obj.type === "success") {
        let params = {
          orderNumber: this.detail.no,
          remark: obj.data.form.backRemark,
          isInRepository: obj.data.form.backState == 1 ? true : false, // 是否入库
          returnGoods: this.returnGoods,
          replaceGoods: obj.data.table,
        };
        console.log(params);
        let loading = this.$loading();
            this.$http
              .post("/api/ReturnOrder/ReplaceOrder", params)
              .then((res) => {
                loading.close();
                if (res.code == 0) {
                  this.dialogReturnGoodsState = false;
                  this.returnOrderId = res.data;
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.dialogSettlementState = true;
                  // this.getDetail();
                }
              });
          
      }
    },
    // submit_退货
    addOrderReturnGoods() {
      // if (this.remark.length < 15) {
      //   this.$message({
      //     message: "退货备注须大于15个字",
      //     type: "error",
      //   });
      //   return;
      // }
      if (this.detail.order_type_id == 10) {
        console.log("订金退货");
        let params = {
          orderNo: this.detail.no,
          remark: this.remark,
          isInRepository: this.form1.backState == 1 ? true : false, // 是否入库
          returnGoods: this.returnGoods,
          coupon_list: this.detail.coupon_list,
          returnAccountParam: this.returnAccountParam,
          isReturnYuE: this.isReturnYuE,
        };

        let loading = this.$loading();
        this.$http
          .post("/api/ReturnOrder/Return/LivingAdvance", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              console.log("订金成功", res.data);
              this.returnOrderId = res.data;
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogReturnGoodsState1 = false;
              this.dialogSettlementState = true;
              // this.getDetail();
            }
          });
      } else {
        let params = {
          orderNumber: this.detail.no,
          remark: this.remark,
          isInRepository: this.form1.backState == 1 ? true : false, // 是否入库
          returnGoods: this.returnGoods,
          coupon_list: this.detail.coupon_list,
          returnAccountParam: this.returnAccountParam,
          isReturnYuE: this.isReturnYuE,
          pay_list: this.payList,
        };
        console.log(params);
        let loading = this.$loading();
        this.$http.post("/api/ReturnOrder/Order", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            // this.returnOrderId = res.data;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail();
            this.dialogReturnGoodsState1 = false;
            // this.dialogSettlementState = true;
            // this.getDetail();
          }
        });
      }
    },
    // 结算完成关闭弹窗
    dialogSettlementSubmit(a) {
      this.dialogSettlementState = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        // this.$router.push({path:'/orderReturnGoods/orderReturnGoodsSee',query:{id:this.returnOrderId}})
      }
      this.getDetail();
    },
    // 计算 换货列表 总计
    getTotal() {
      this.form_table_totalMoney = 0;
      for (let i = 0; i < this.form.table.length; i++) {
        if (this.form.table[i].gift !== "gift") {
          this.form_table_totalMoney = this.$public.toDoubleFixed2(
            this.form_table_totalMoney +
              this.$public.toDoubleFixed2(
                this.form.table[i].price * this.form.table[i].num
              )
          );
        }
      }
    },
    getUserDetail(id) {
      let params = {
        id: id,
      };
      this.$http.get(process.env.VUE_APP_Url_member+"/api/middleware/Member/Single", params).then((res) => {
        if (res.code == 0) {
          this.userDetail = res.data;
        }
      });
    },
    // 礼品卡
    getGiftCardList(detail) {
      let giftCardList = [];
      if (detail.pay_info && detail.pay_info.gift_card_list) {
        giftCardList = detail.pay_info.gift_card_list;
      }
      this.giftCardList = giftCardList;
    },
    // 获取详情
    getDetail() {
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url_order +
            "/api/OffLineOrder/" +
            this.$route.query.id
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.getUserDetail(res.data.user_info.user_id);
            this.getGiftCardList(res.data);
            this.detail = res.data;
            //   console.log('详情1111', res.data)
            this.tableData = [];
            for (let i = 0; i < this.detail.order_item_list.length; i++) {
              let one = {
                pets_info: this.detail.order_item_list[i].pets_info, // 用量
                activityId:
                  this.detail.order_item_list[i].activity_info &&
                  this.detail.order_item_list[i].activity_info.activity_id, // 活动id
                activityName:
                  this.detail.order_item_list[i].activity_info &&
                  this.detail.order_item_list[i].activity_info.activity_name, // 活动名称
                activityType:
                  this.detail.order_item_list[i].activity_info &&
                  this.detail.order_item_list[i].activity_info.activity_type,
                goodsDosage: "", // 用量
                goodsId: this.detail.order_item_list[i].goods_id, // 商品id
                goodsName: this.detail.order_item_list[i].goods_name, // 商品名称
                petTag:this.detail.order_item_list[i].pet_tag,
                goodsItemsId: this.detail.order_item_list[i].goods_items_id,
                order_item_id: this.detail.order_item_list[i]._id,
                goodsList: [], // children
                goodsType: this.detail.order_item_list[i].goods_type, // 1:商品；2:服务；3:套餐
                goodsUsage: "", // 用法
                _id: this.detail.order_item_list[i]._id,
                isPay: this.detail.state, // 是否支付
                num: this.detail.order_item_list[i].num, // 数量
                originalPrice: this.detail.order_item_list[i].original_price, // 原价
                price: this.detail.order_item_list[i].price, // 现价
                remark: this.detail.order_item_list[i].remarks, // 备注
                model: this.detail.order_item_list[i].sku_value, // 规格
                skuValue: this.detail.order_item_list[i].sku_value, // 规格
                barCode:this.detail.order_item_list[i].bar_code,
                skus: this.detail.order_item_list[i].skus_id, // 规格
                totalMoney: (
                  this.detail.order_item_list[i].num *
                  this.detail.order_item_list[i].price
                ).toFixed(2), // 总价
                unit: this.detail.order_item_list[i].unit, // 单位
                staff: "",
                sales_list: [],
                validityStopDate:
                  this.detail.order_item_list[i].validity_stop_date,
                returnState: false, //一级选中状态
                packingWayId: this.detail.order_item_list[i].packing_way_id,
              };
              if (this.detail.order_item_list[i].sales_list) {
                one.sales_list = this.detail.order_item_list[i].sales_list;
                for (
                  let b = 0;
                  b < this.detail.order_item_list[i].sales_list.length;
                  b++
                ) {
                  one.staff +=
                    this.detail.order_item_list[i].sales_list[b].sales_name +
                    " ";
                }
              }

              if (
                this.detail.order_item_list[i].goods_type == 2 ||
                this.detail.order_item_list[i].goods_type == 4
              ) {
                // 服务
                one.tableKey = "tableKey_service_one" + Math.random();
                one.customCode =
                  "service" + i + this.detail.order_item_list[i].goods_name;
              } else if (
                this.detail.order_type_id == 1 ||
                this.detail.order_type_id == 10 ||
                this.detail.order_type_id == 8 ||
                this.detail.order_type_id == 9
              ) {
                // 商品
                one.tableKey = "tableKey_goods_one" + Math.random();
                one.customCode = "customCode_goods_one" + Math.random();
               
              }
              this.tableData.push(one);
              // console.log('商品列表', this.tableData)
            }
          }
        });
    },
    // 是否发票
    addIsHaveInvoices() {
      let params = {
        order_id: this.detail._id,
      };
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url_order + "/api/OffLineOrder/AddInvoicesAsync",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail();
          }
        });
    },
    delIsHaveInvoices() {
      let params = {
        order_id: this.detail._id,
      };
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url_order +
            "/api/OffLineOrder/DeleteInvoicesAsync",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail();
          }
        });
    },
    // 修改销售人员
    changeStaff(row) {
      this.curRow = row;
      this.curStaffId = [];
      for (let b = 0; b < row.sales_list.length; b++) {
        this.curStaffId.push(row.sales_list[b].sales_id);
      }
      this.curStaffId_state = true;
    },
    submit_curStaffId() {
      let sales_list = [];
      for (let i = 0; i < this.curStaffId.length; i++) {
        sales_list.push({
          sales_id: this.curStaffId[i],
          sales_name: this.$public.getMatchingItem(
            this.staffList,
            "_id",
            this.curStaffId[i]
          ).basic_info.nick_name,
        });
      }
      let params = {
        order_id: this.detail._id,
        order_item_id: this.curRow.order_item_id,
        sales_list: sales_list,
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_order +
            "/api/OffLineOrder/UpdateSaleManByOrderItemId",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code === 0) {
            this.curStaffId_state = false;
            this.getDetail();
          }
        });
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/List", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
          res.data.data.forEach((item) => {
            const obj = {
              id: item._id,
              name: item.basic_info.nick_name,
            };
            this.staffList1.push(obj);
          });
        }
      });
    },
    // 修改结算方式
    changePayInfo() {
      this.dialogSettlementState_payInfo = true;
    },
    dialogSettlementSubmit_payInfo(a) {
      this.dialogSettlementState_payInfo = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "操作失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.getDetail();
        // this.$router.push({path:'/orderReturnGoods/orderReturnGoodsSee',query:{id:this.returnOrderId}})
      }
    },
  },
};
</script>
<style scoped lang="scss">
.msgBox {
  display: flex;
  // padding: 20px;
  margin-bottom: 10px;
  & > span {
    display: inline-block;
    padding: 20px;
    text-align: right;
  }
  .msgV {
    line-height: 54px;
  }
  .msgBoxL {
    height: 56px;
    line-height: 56px;
  }
}
.page {
  .pageTitleBox {
  }
  .msg {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 4px;
    .msgItem {
      width: 25%;
      font-size: 16px;
      color: $fontColor;
      display: flex;
      line-height: 40px;
      padding: 0 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #f2f2f2;
      font-size: 12px;
      .msgLabel {
        width: 80px;
        text-align: right;
        color: $fontColor;
      }

      .msgValue {
      }
    }
  }
  .pageConBox {
    min-height: 600px;
    margin-top: 12px;
  }
}
</style>
